<script setup lang="ts"></script>

<template>
  <v-card class="header-container">
    <img class="logo-container" src="../../assets/binkey-logo.svg" />
  </v-card>
</template>
